import angular from 'angular';
import SmsNotificationTabComponent from './components/sms-notification-tab/sms-notification-tab-component';
import SmsNotificationEditComponent from './components/sms-notification-edit/sms-notification-edit-component';

export default angular.module('sms-notification-templates', ['email-notification-templates', SmsNotificationTabComponent.name, SmsNotificationEditComponent.name]);



// WEBPACK FOOTER //
// ./src/modules/sms/components/sms-notification-templates/sms-notification-templates-component.js